export const GLOBAL_IMAGES_ACTION_PATH = '/global-images';

export enum GlobalImageIntent {
  ChangeDescription = 'change-description',
  MakePrimary = 'make-primary',
  Delete = 'delete',
}

export enum ImageType {
  ClientItemMaster = 'ClientItemMaster',
  Substitution = 'Substitution',
}
